/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Program api models
  Date: April 2020
**/

import { action, thunk } from 'easy-peasy';
import * as programsService from '../../services/programs';

var programInfoList = [];
const programModel = {
  isProgramInfoLoaded: false,
  setIsProgramInfoLoaded: action((state, payload) => {
    state.isProgramInfoLoaded = payload;
  }),

  programList: [],
  setProgramList: action((state, payload) => {
    state.programList = payload;
  }),
  programListLoader: false,
  setProgramListLoader: action((state, payload) => {
    state.programListLoader = payload;
  }),
  getProgramList: thunk(async (actions, payload) => {
    await programsService.getProgramList(payload)
      .then(function (response) {
        actions.setProgramListLoader(false);
        actions.setIsProgramInfoLoaded(true);
        programInfoList = response.data.data.items;
        actions.setProgramList(programInfoList);
        return response.data.data.items;
      })
      .catch(function (error) {
        actions.setProgramListLoader(false);
        actions.setIsProgramInfoLoaded(true);
        actions.setProgramList([]);
      });
  }),
};

export default programModel;
